/**
 * Visual progress bar for a single kit line item.
 * Shows current/initial qty with color cues:
 *  - green: ≥3 remaining
 *  - amber: 1-2 remaining
 *  - red: 0 remaining
 */
export function KitItemBar({ item }) {
  const initial = item.qty_initial || 1;
  const current = item.qty_current ?? 0;
  const pct = Math.max(0, Math.min(100, (current / initial) * 100));
  let color = '#39FF14';
  let textColor = 'text-[#39FF14]';
  if (current === 0) {
    color = '#FF3B30';
    textColor = 'text-[#FF3B30]';
  } else if (current <= 2) {
    color = '#FF9F0A';
    textColor = 'text-[#FF9F0A]';
  }
  return (
    <div className="space-y-1" data-testid={`kit-item-${item.product_id}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-[#A3C7A8] font-mono text-xs truncate">
          {item.product_name}
        </span>
        <span className={`${textColor} font-mono text-xs font-bold`}>
          {current}/{initial}
        </span>
      </div>
      <div className="h-1.5 bg-[#2A0F3D] overflow-hidden">
        <div
          className="h-full transition-all duration-300"
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
    </div>
  );
}

export function kitTotalValue(items = []) {
  return items.reduce((sum, i) => sum + (i.price || 0) * (i.qty_current || 0), 0);
}
